import { Box, Stack, Typography } from "@mui/material";
import React, { Fragment } from "react";

const DarkWebOverviewData = (props) => {
	
	const valueBoxStyle = {
		border: "2px solid #ff03ed",
		width: "70%",
		height: "2.2em",
		fontSize: "1.5em",
		borderRadius: "0.5em",
		textAlign: "center",
		margin: "0.5em",
		paddingTop: "0.3em",
		":hover": {
			cursor: "pointer"
		}
	};
	
	const labelStyle = {
		fontSize: "1em"
	};

	return (
		<Fragment>{props.totals != null &&
			<Stack
				direction="row"
				spacing="1em"
				alignItems="center"
				justifyContent="space-evenly"
				sx={{ width: "100%", paddingBottom: "1em" }}
			>
				<Stack direction="column" justifyContent="center" alignItems="center">
					<Typography sx={labelStyle}>
						Exposed Accounts
					</Typography>
					<Box sx={valueBoxStyle} onClick={props.handleShowCredentials}>
						{props.totals.compromisedAccounts}
					</Box>
				</Stack>
				<Stack direction="column" justifyContent="center" alignItems="center">
					<Typography sx={labelStyle}>
						Exposed Passwords
					</Typography>
					<Box sx={valueBoxStyle} onClick={props.handleShowCredentials}>
						{props.totals.passwords}
					</Box>
				</Stack>
				<Stack direction="column" justifyContent="center" alignItems="center">
					<Typography sx={labelStyle}>
						Exposed Data Items
					</Typography>
					<Box sx={valueBoxStyle} onClick={props.handleShowCredentials}>
						{props.totals.dataItems}
					</Box>
				</Stack>
				<Stack direction="column" justifyContent="center" alignItems="center">
					<Typography sx={labelStyle}>
						Exposed Data Types
					</Typography>
					<Box sx={valueBoxStyle} onClick={props.handleShowBreaches}>
						{props.totals.dataTypes}
					</Box>
				</Stack>
				<Stack direction="column" justifyContent="center" alignItems="center">
					<Typography sx={labelStyle}>
						Breaches Discovered
					</Typography>
					<Box sx={valueBoxStyle} onClick={props.handleShowBreaches}>
						{props.totals.breaches}
					</Box>
				</Stack>
			</Stack>
		}</Fragment>
	)
};

export default DarkWebOverviewData;